import _ from 'lodash';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { translationPropType } from '@eb/i18n';
import Heading from './Heading';
import {
    HEADING_PROP_TYPES,
    HEADING_PROPS,
} from '../constants/componentPropTypes';

import { Graphic } from '@eb/eds-graphic';
import { Button } from '@eb/eds-button';
import { STYLE_FILL } from '@eb/eds-button';

export default class PackageSelectionPrompt extends PureComponent {
    static propTypes = {
        ...HEADING_PROP_TYPES,
        /*
        Primary CTA text
        */
        primaryCTA: translationPropType.isRequired,
        /*
        Actions to be triggered from selecting main CTA button
        */
        onPrimaryCTAClick: PropTypes.func.isRequired,
        /*
        graphic to show above the heading
        */
        graphic: PropTypes.string.isRequired,
        /*
        graphic size in pixels
        */
        graphicSize: PropTypes.string.isRequired,
        /*
        data automation tag
        */
        dataAutomationTag: PropTypes.string,
    };

    render() {
        const {
            onPrimaryCTAClick,
            primaryCTA,
            graphic,
            graphicSize,
            dataAutomationTag,
            ...packageSelectionProps
        } = this.props;
        const headingProps = _.pick(packageSelectionProps, HEADING_PROPS);

        return (
            <div className="eds-g-cell eds-g-cell-1-1 eds-g-offset-md-1-12 eds-g-cell-md-10-12 eds-l-pad-vert-14 eds-l-mar-top-14">
                <div
                    className="eds-text--center"
                    data-automation={dataAutomationTag}
                >
                    <Graphic type={graphic} size={graphicSize} />
                </div>
                <Heading
                    {...headingProps}
                    alignCenter={true}
                    removeVerticalPadding={true}
                />
                <div className="eds-text--center eds-l-pad-top-10">
                    <Button style={STYLE_FILL} onClick={onPrimaryCTAClick}>
                        {primaryCTA}
                    </Button>
                </div>
            </div>
        );
    }
}
